import { gql } from '@apollo/client';

export const CREATE_IDENTITY_VERIFICATION_MUTATION = gql`
  mutation createVerificationSession {
    createVerificationSession
  }
`;
